module.exports = __webpack_public_path__ + "static/media/background-marcas.7c38419c.jpg";